export type ArenaType = {
  label: string;
  value: string;
  speciesAllowed: Array<number>
};

export const arenaInventory: Array<ArenaType> = [
  { label: 'Desert', value: '1', speciesAllowed: [0, 101] },
  { label: 'Cyber City', value: '2', speciesAllowed: [0, 101] },
  { label: 'Unstoppable Domains', value: '101', speciesAllowed: [101] }
];
